"use client";

import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import CustomButton from "../../common/CustomButton";
import PopUpModal from "../../common/PopUpModal";
import { SuccessfulPage } from "../../common/SuccessfulPage";
import { useState } from "react";

export const SurgicalProcedureForm = () => {
  const initialValues = {
    surgeonName: "",
    assistantName: "",
    surgeryDescription: "",
    cptCode:"",
    time: "",
    date: "",
    city: "",
    MedicalFacility: "",
    patientName: "",
    insuranceDetails: "",
    emergencyContactName: "",
    emergencyContactPhone: "",
    specialInstruction: "",
  };

  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({
    title: "",
    message: "",
    status: "",
  });

  const validationSchema = Yup.object({
    surgeonName: Yup.string().required("Surgeon name is required"),
    assistantName: Yup.string().optional(),
    surgeryDescription: Yup.string().required("Surgical description is required"),
    cptCode: Yup.string().required("CPT/DX code is required"),
    time: Yup.string().required(),
    date: Yup.string().required(),
   // city: Yup.string().required("City is required"),
    MedicalFacility: Yup.string().required("Facility is required"),
    patientName: Yup.string().required("Patient name is required"),
    insuranceDetails: Yup.string().optional(),
    emergencyContactName: Yup.string().required("Contact person name is required"),
    emergencyContactPhone: Yup.string()
      .matches(/^\d{10}$/, "Phone number must be 10 digits")
      .required("Phone number is required"),
    specialInstruction: Yup.string().optional(),
  });

  const Label = ({ title }) => (
    <p
      className="f-w-400 font-nunito-sans p-16 color-black form-label"
      style={{
        marginBottom: "5px",
      }}
    >
      {title}
      {/* <span style={{ color: "red" }}> *</span> */}
    </p>
  );

  const handleOnSubmit = async (values, { resetForm }) => {
    console.log("form submitted:", values);
    try {
      const response = await fetch("/api/schedule-surgical", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(values),
      });
console.log(response);
      const api = await response.json();
      console.log("Response from API:", api);

      if (response.ok) {
        setModalData({
          title: "Successful!",
          message: "Thank you for reaching out! We'll get back to you soon.",
          status: "success",
        });
        resetForm();
      } else {
        console.log(`Error: ${api.error || "Something went wrong"}`);
        setModalData({
          title: "Error!",
          message: api.error || "Something went wrong",
          status: "err",
        });
      }
    } catch (errors) {
      setModalData({
        title: "Sorry :(",
        message: "An unexpected error occurred. Please try again later.",
        status: "err",
      });
    } finally {
      setShowModal(true);
    }
  };

  return (
    <>
      <div className="surgical-form ">
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleOnSubmit}>
          {({ values, errors, touched }) => (
            <Form>
              <div className="form">
                <div className="form-data">
                  <div className="flex form-row" style={{ gap: "20px" }}>
                    {console.log("errors -- " , errors)}
                    <div className="left-row">
                      <Label title="Surgeon's Name" />
                      <Field
                        type="text"
                        name="surgeonName"
                        placeholder="Eg: Dr. John"
                        className={`field-box ${errors.surgeonName && touched.surgeonName ? "error" : ""}`}
                      />
                    </div>
                    <div className="flex-1">
                      <Label title="Preferred Assistant Requested" />
                      <Field
                        type="text"
                        name="assistantName"
                        placeholder="Eg: Paul"
                        className={`field-box ${errors.assistantName && touched.assistantName ? "error" : ""}`}
                      />
                    </div>
                  </div>
                </div>

                {/* <div className="form-data">
                  <Label title="Preferred Assistant Requested" />
                  <Field
                    type="text"
                    name="assistantName"
                    placeholder="Eg: Paul"
                    className={`field-box ${errors.assistantName && touched.assistantName ? "error" : ""}`}
                  />
                </div> */}

                <div className="form-data">
                  <div className="flex form-row" style={{ gap: "20px" }}>
                    <div className="left-row">
                      <Label title="Surgical Procedure Description" />
                      <Field
                        as="textarea"
                        name="surgeryDescription"
                        placeholder="Procedure with CPT Code"
                        className={`field-box ${errors.surgeryDescription && touched.surgeryDescription ? "error" : ""}`}
                      />
                    </div>
                    <div className="flex-1">
                      <Label title="CPT & DX Codes" />
                      <Field
                        as="textarea"
                        name="cptCode"
                        placeholder="Procedure with CPT Code"
                        className={`field-box ${errors.cptCode && touched.cptCode ? "error" : ""}`}
                      />
                    </div>
                  </div>
                </div>

                <div className="form-data">
                  <div className="form-row" style={{ gap: "20px" }}>
                    <div className="left-row">
                      <Label title="Surgical Facility Name" />
                      <Field
                        type="text"
                        name="MedicalFacility"
                        placeholder="Eg: Universal"
                        className={`field-box ${errors.Medicalfacility && touched.Medicalfacility ? "error" : ""}`}
                      />
                    </div>

                    <div className="flex-1">
                      <Label title="Patient's Name" />
                      <Field
                        type="text"
                        name="patientName"
                        placeholder="Eg: Eve"
                        className={`field-box ${errors.patientName && touched.patientName ? "error" : ""}`}
                      />
                    </div>
                  </div>
                </div>

                <div className="form-data">
                  <div className="flex form-row" style={{ gap: "20px" }}>
                    <div className="left-row">
                      <Label title="Surgery Start Time" />
                      <Field type="time" name="time" placeholder="23:23:am" className={`field-box ${errors.time && touched.time ? "error" : ""}`} />
                    </div>
                    <div className="flex-1">
                      <Label title="Surgery Date " />
                      <Field type="date" name="date" placeholder="dd-mm-yyyy" className={`field-box ${errors.date && touched.date ? "error" : ""}`} />
                    </div>
                  </div>
                </div>

                {/* <div className="form-data">
                  <Label title="City" />
                  <Field type="text" name="city" placeholder="Eg: Texas*" className={`field-box ${errors.city && touched.city ? "error" : ""}`} />
                </div> */}

                {/* <div className="form-data">
                  <Label title="Insurance Carrier Information" />
                  <Field
                    type="text"
                    name="insuranceDetails"
                    placeholder="Insurance info..."
                    className={`field-box ${errors.insuranceDetails && touched.insuranceDetails ? "error" : ""}`}
                  />
                </div> */}

                <div className="form-data">
                  <div className="form-row" style={{ gap: "20px" }}>
                    <div className="left-row">
                      <Label title="Contact Person’s Name" />
                      <Field
                        type="text"
                        name="emergencyContactName"
                        placeholder="James"
                        className={`field-box ${errors.emergencyContactName && touched.emergencyContactName ? "error" : ""}`}
                      />
                    </div>

                    <div className="flex-1">
                      <Label title="Contact Phone" />
                      <div className="b-r-5 phone-style color-ligh-grey flex">
                        <div className="svg flex center-center">
                          <img src="/images/svg-icon/usa.svg" alt="usa" />
                          <span style={{ padding: "0 0 0 5px" }}>+1</span>
                        </div>

                        <Field
                          name="emergencyContactPhone"
                          type="text"
                          placeholder="XXX-XXX-XXXX"
                          className={`b-r-0 ${errors.emergencyContactPhone && touched.emergencyContactPhone ? "error" : ""}`}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-data">
                  <Label title="Special Instructions" />
                  <Field
                    as="textarea"
                    name="specialInstruction"
                    placeholder="Eg, Patient has allergy ..."
                    className={`field-box ${errors.specialInstruction && touched.specialInstruction ? "error" : ""}`}
                  />
                </div>
              </div>

              <div>
                <CustomButton
                  style={{ width: "100%" }}
                  type="submit"
                  theme="primary"
                  title="Submit Now"
                  disabled={
                    !values.surgeonName ||
                    !values.surgeryDescription ||
                    !values.cptCode ||
                    !values.time ||
                    !values.date ||
                   // !values.city ||
                    !values.MedicalFacility ||
                    !values.patientName ||
                    !values.emergencyContactName ||
                    !values.emergencyContactPhone ||
                    loading
                  }
                />
              </div>
            </Form>
          )}
        </Formik>
      </div>
      {showModal && (
        <PopUpModal onClose={() => setShowModal(false)}>
          <SuccessfulPage modalData={modalData} onClose={() => setShowModal(false)} />
        </PopUpModal>
      )}
    </>
  );
};
